module.exports = __webpack_public_path__ + "5eeec6f10c9e7871cc4d0e1042ca36f5.svg";